import type React from 'react';
import { PANEL_ADJUSTMENT_NAMES } from 'config/labels';

export type CPRPanelPopup = {
  [Key in keyof typeof PANEL_ADJUSTMENT_NAMES]?: boolean;
};

export type CaptureSetterType = {
  setter: (key: number, params: any) => void;
  key: number;
  keys: string[];
  branchIndex: number[];
  refSVG: React.RefObject<SVGSVGElement>;
};

export const initialPopup: CPRPanelPopup = {
  projection: false,
  preset: false,
};

export type CprPanelMode = 'straightened' | 'stretched';

export type ToggleKey =
  | 'lesionline'
  | 'isrline'
  | 'stenosisline'
  | 'guideline'
  | 'markerline'
  | 'plaqueoutline'
  | 'lumenoutline'
  | 'fai'
  | 'plaque'
  | 'lumen'
  | 'aorta'
  | 'all';
